import { Link } from "react-router-dom";
import styled from "styled-components";

import { blueMui } from "@ryde/theme";

export const CommonLinkStyled = styled(Link)`
  color: ${blueMui.A400};
  text-decoration: underline;
`;
